import httpService from "../../services/httpService";
import { ApiEndpoints } from "../../constants/apiEndpoints";

// Enums - Backend README'ye göre düzeltilmiş
export enum SongRequestStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  COMPLETED = "completed",  // Backend'de completed var
}

export enum SongRequestPriority {
  LOW = "low",
  MEDIUM = "medium",  // Backend'de medium (NOT normal!)
  HIGH = "high",
}

// Status Update Interface
export interface StatusUpdateRequest {
  status: SongRequestStatus;
  priority?: SongRequestPriority;
  admin_notes?: string;
  estimated_completion?: string;
}

// Interfaces - Backend README'ye göre düzeltilmiş
export interface SongRequest {
  _id: string; // MongoDB object ID
  request_id: string; // Unique request ID (UUID)
  user_id: string; // Firebase UID
  user_name: string; // Request yapan kullanıcının ismi
  user_email: string; // Request yapan kullanıcının emaili
  
  // Song information - Backend README'deki field isimleri
  song_name: string;        // Backend'de song_name (NOT song_title!)
  artist_name: string;
  song_link: string;        // YouTube URL
  notes?: string;           // Backend'de notes (NOT description!)
  
  // Request information
  priority: "low" | "medium" | "high";  // Backend enum
  status: "pending" | "approved" | "rejected" | "completed";  // Backend enum
  
  // Timestamps
  created_at: string;       // ISO 8601
  updated_at: string;       // ISO 8601
  
  // Admin information
  admin_notes?: string;
}

export interface CreateSongRequestData {
  song_name: string;        // Backend'de song_name (Required)
  artist_name: string;      // Required
  song_link: string;        // YouTube URL (Required)
  notes?: string;           // Backend'de notes (Optional)
  priority?: "low" | "medium" | "high";  // Optional, default: medium
}

export interface UpdateSongRequestData {
  status?: SongRequestStatus;
  priority?: SongRequestPriority;
  admin_notes?: string; // Max 1000 chars
  estimated_completion?: string; // DateTime
}

// Normal user'ın kendi request'lerini getir - Collection: GET /song-requests/my
export const fetchMySongRequests = async (): Promise<SongRequest[]> => {
  const response = await httpService.get<SongRequest[]>(
    ApiEndpoints.MY_SONG_REQUESTS
  );
  return response.data;
};

// Admin - Tüm request'leri getir - Collection: GET /song-requests/admin/all
export const fetchAllSongRequests = async (): Promise<SongRequest[]> => {
  const response = await httpService.get<any>(ApiEndpoints.ADMIN_SONG_REQUESTS);
  return response.data.data || response.data; // Collection response'da data.data yapısı var
};

export const fetchSongRequest = async (id: string): Promise<SongRequest> => {
  // Tek bir song request için doğru endpoint kullanmalıyız
  const response = await httpService.get<SongRequest>(
    `song-requests/admin/${id}`
  );
  return response.data;
};

export const createSongRequest = async (
  data: CreateSongRequestData
): Promise<SongRequest> => {
  const response = await httpService.post(ApiEndpoints.SONG_REQUESTS, data);
  return response.data as SongRequest;
};

export const updateSongRequest = async (
  id: string,
  data: Partial<CreateSongRequestData>
): Promise<SongRequest> => {
  const response = await httpService.put(
    `${ApiEndpoints.SONG_REQUESTS}/${id}`,
    data
  );
  return response.data as SongRequest;
};

export const approveSongRequest = async (
  request_id: string,
  admin_notes?: string
): Promise<void> => {
  await httpService.post(`song-requests/admin/${request_id}/approve`, {
    ...(admin_notes && { admin_notes }),
  });
};

export const rejectSongRequest = async (
  request_id: string,
  admin_notes?: string
): Promise<void> => {
  await httpService.post(`song-requests/admin/${request_id}/reject`, {
    ...(admin_notes && { admin_notes }),
  });
};

export const deleteSongRequest = async (id: string): Promise<void> => {
  await httpService.delete(`${ApiEndpoints.SONG_REQUESTS}/${id}`);
};

// Status Update Function - Backend README'ye göre düzeltilmiş
// PUT /api/song-requests/admin/{request_id}/status
export const updateSongRequestStatus = async (
  request_id: string,
  status: "pending" | "approved" | "rejected" | "completed",
  admin_notes?: string
): Promise<void> => {
  await httpService.put(`song-requests/admin/${request_id}/status`, {
    status,
    ...(admin_notes && { admin_notes })
  });
};

// YENİ: Admin statistics endpoint
export const fetchSongRequestStats = async (): Promise<any> => {
  const response = await httpService.get(ApiEndpoints.ADMIN_SONG_REQUEST_STATS);
  return response.data;
};
